module.exports = __webpack_public_path__ + "media/Ringtone3.a8d3b3c0.mp3";